// const outcome = getInspectionOutcome(inspection);

import { Image, Text, View } from '@react-pdf/renderer';

import { VehicleInspectionReportExtraDetailsRead } from 'src/common/external/bambi-api/bambiApi';
import { commonStyles } from 'src/common/pdf/common.styles';

import { getInspectionOutcome } from '../../util/getInspectionOutcome';

interface VehicleInspectionReportOutcomeSectionProps {
  reportItems: VehicleInspectionReportExtraDetailsRead['report_json'];
  signatures?: VehicleInspectionReportExtraDetailsRead['signatures_as_base64'];
}
export function VehicleInspectionReportOutcomeSection({
  reportItems,
  signatures = [],
}: VehicleInspectionReportOutcomeSectionProps) {
  return (
    <View style={[{ width: '100%' }, commonStyles.textMd]}>
      <Text style={commonStyles.strong}>Outcome</Text>
      <View style={[commonStyles.rowBg, { padding: 6 }]}>
        <Text>
          Outcome:
          <Text style={commonStyles.strong}>
            &nbsp;
            {getInspectionOutcome(reportItems)}
          </Text>
        </Text>
      </View>
      <View style={{ flexDirection: 'row', gap: 4 }}>
        {signatures.map((signature) => {
          return (
            <Image
              key={signature}
              src={signature}
              style={{
                width: 100,
                height: 50,
              }}
            />
          );
        })}
      </View>
    </View>
  );
}
